module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product) ? _c('div', {
    staticClass: "donation-selection",
    attrs: {
      "id": "donate-step1"
    }
  }, [_c(_vm.packageCarousel, {
    tag: "component"
  }), _vm._v(" "), (!_vm.isAdoption && !_vm.isWildcard) ? _c('div', {
    staticClass: "tab-selector"
  }, _vm._l((_vm.product.donationtypes), function(donationType) {
    return _c('div', {
      staticClass: "single-tab",
      class: {
        selected: donationType === _vm.currentDonationType
      },
      on: {
        "click": function($event) {
          _vm.selectDonationType(donationType);
          _vm.logFirstTouch('donation type');
        }
      }
    }, [_vm._v("\n      " + _vm._s(donationType == "Regular" ? "Give monthly" : "Give once") + "\n    ")])
  })) : _vm._e(), _vm._v(" "), (_vm.isAdoption) ? _c('div', {
    staticClass: "tab-selector"
  }, [_c('div', {
    staticClass: "single-tab",
    class: {
      selected: !_vm.isGiftSelected
    },
    on: {
      "click": function($event) {
        _vm.toggleIsGift(false);
        _vm.logFirstTouch('gift');
      }
    }
  }, [_vm._v("\n      For you\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "single-tab",
    class: {
      selected: _vm.isGiftSelected
    },
    on: {
      "click": function($event) {
        _vm.toggleIsGift(true);
        _vm.logFirstTouch('gift');
      }
    }
  }, [_vm._v("\n      As a gift\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.isAdoption || _vm.isWildcard) ? _c('h2', [_vm._v("\n    " + _vm._s(_vm.donation.type == "Regular" ? "Give monthly" : "Give once") + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dollar-handle-selector"
  }, [_vm._l((_vm.dollarHandles), function(dollarHandle) {
    return _c('label', {
      attrs: {
        "for": 'handle-' + _vm.currentDonationType + '-' + dollarHandle.amount
      }
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedDollarHandle),
        expression: "selectedDollarHandle"
      }],
      attrs: {
        "type": "radio",
        "name": 'handle-' + _vm.currentDonationType,
        "id": 'handle-' + _vm.currentDonationType + '-' + dollarHandle.amount,
        "data-vv-as": "amount"
      },
      domProps: {
        "value": dollarHandle,
        "checked": _vm._q(_vm.selectedDollarHandle, dollarHandle)
      },
      on: {
        "focus": function($event) {
          _vm.logFirstTouch('dollar handle')
        },
        "change": function($event) {
          _vm.selectedDollarHandle = dollarHandle
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "amount"
    }, [_c('span', [_vm._v(_vm._s(_vm.formatDollarHandle(dollarHandle.amount)))])])])
  }), _vm._v(" "), (_vm.proposeCustomAmount) ? _c('label', {
    attrs: {
      "for": 'handle-' + _vm.currentDonationType + '-custom'
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedDollarHandle),
      expression: "selectedDollarHandle"
    }],
    attrs: {
      "type": "radio",
      "name": 'handle-' + _vm.currentDonationType,
      "id": 'handle-' + _vm.currentDonationType + '-custom',
      "value": "custom"
    },
    domProps: {
      "checked": _vm._q(_vm.selectedDollarHandle, "custom")
    },
    on: {
      "change": function($event) {
        _vm.selectedDollarHandle = "custom"
      }
    }
  }), _vm._v(" "), _vm._m(0, false, false)]) : _vm._e()], 2), _vm._v(" "), (_vm.isCustomSelected) ? _c('div', [(_vm.proposeCustomAmount) ? _c('div', {
    staticClass: "wwf-field icon"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.amount),
      expression: "donation.amount"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        donationCustomAmountIsValid: true
      }),
      expression: "{ required: true, donationCustomAmountIsValid: true }"
    }],
    ref: "customAmount",
    class: {
      empty: !_vm.donation.amount,
        error:
        _vm.errors.has('customAmount') ||
        _vm.errors.has('donationCustomAmountIsValid'),
    },
    attrs: {
      "id": "customAmount",
      "name": "customAmount",
      "type": "number",
      "data-vv-validate-on": "change",
      "data-vv-as": "Custom Amount"
    },
    domProps: {
      "value": (_vm.donation.amount)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('dollar handle')
      },
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation, "amount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": 'handle-' + _vm.currentDonationType + '-custom'
    }
  }, [_vm._v("\n        Custom amount\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(
    _vm.errors.has('customAmount') ||
    _vm.errors.has('donationCustomAmountIsValid')
  ) ? _c('p', [_vm._v("\n          " + _vm._s(_vm.errors.first("customAmount")) + "\n        ")]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMaxAmountMessage),
      expression: "showMaxAmountMessage"
    }],
    staticClass: "message-max-amount"
  }, [_c('p', [_vm._v("\n      For donations above $75,000 please contact our Impact Partnerships team,\n      so we can be sure your gift benefits the area of conservation you are\n      most passionate about.\n    ")]), _vm._v(" "), _vm._m(2, false, false)]), _vm._v(" "), (_vm.isDollarHandleSelected) ? _c('div', {
    staticClass: "dollar-handle-selected"
  }, [_c('span', [_vm._v(_vm._s(_vm.selectedDollarHandle.text))])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.first('handle-' + _vm.currentDonationType)) ? _c('p', [_vm._v("\n      Please choose your donation amount\n    ")]) : _vm._e()]), _vm._v(" "), (_vm.showInLovingMemory) ? _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.inMemoryOf),
      expression: "donation.inMemoryOf"
    }],
    class: {
      empty: !_vm.donation.inMemoryOf
    },
    attrs: {
      "name": "name",
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.donation.inMemoryOf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation, "inMemoryOf", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "In Loving Memory of"
    }
  }, [_vm._v("In Loving Memory of")])]) : _vm._e(), _vm._v(" "), (_vm.showTaxCalculator) ? _c('tax-calculator', {
    attrs: {
      "amount": _vm.donation.amount
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "payment-type-selector"
  }, [_c('button', {
    staticClass: "plain",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.selectPaymentType('wwf_purchasetokenise')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.paymentTypeText) + " Credit Card")]), _vm._v(" "), _vm._m(3, false, false)]), _vm._v(" "), (_vm.isPayPalAvailable) ? _c('button', {
    staticClass: "plain",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.selectPaymentType('wwf_paypal')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.paymentTypeText) + " Paypal")]), _vm._v(" "), _vm._m(4, false, false)]) : _vm._e(), _vm._v(" "), (_vm.isDirectDebitAvailable) ? _c('button', {
    staticClass: "plain",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.selectPaymentType('wwf_directdebit')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.paymentTypeText) + " Direct Debit")]), _vm._v(" "), _vm._m(5, false, false)]) : _vm._e()])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "amount"
  }, [_c('span', [_vm._v("$_")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('div', [_vm._v("$_")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      Please email\n      "), _c('a', {
    attrs: {
      "href": "mailto:partnerships@wwf.org.au",
      "target": "_blank"
    }
  }, [_vm._v("partnerships@wwf.org.au")]), _vm._v(". Thank you so much for your kindness!\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fas fa-arrow-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fas fa-arrow-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fas fa-arrow-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac2ea378","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=1udq9m5yalv!./~/string-replace-webpack-plugin/loader.js?id=5v3roo83miv!./src/components/donation/Selection.vue
// module id = 795
// module chunks = 0